import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import './css/style.css';
import './css/satoshi.css';
// Import axios configuration to set up interceptors
import './config/axios';
import { clearStaleChunkFlag, reloadOnceForStaleChunk } from './utils/sessionRecovery';
// Date picker styles
import 'flatpickr/dist/flatpickr.min.css';

// A deploy while this tab was open removes the old lazily loaded chunks; reload once to get the new build.
window.addEventListener('vite:preloadError', (event) => {
  if (reloadOnceForStaleChunk(window.sessionStorage, () => window.location.reload())) event.preventDefault();
});
window.setTimeout(() => clearStaleChunkFlag(window.sessionStorage), 10_000);

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <Router 
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}
    >
      <App />
    </Router>
  </React.StrictMode>,
);
